export const PLAN_DESCRIPTIONS = {
  starter: 'For regular check-ins and monthly planning.',
  growth: 'For people actively improving their money.',
  pro: 'For everyday planning and deeper analysis.',
};

export const PLAN_FEATURES = {
  starter: [
    '100 prompts included',
    'Overage: $0.25 per prompt',
    'Great for budgeting & cashflow',
    'Cancel anytime',
  ],
  growth: [
    '250 prompts included',
    'Overage: $0.25 per prompt',
    'Best for active planning',
    'Most popular',
  ],
  pro: [
    '700 prompts included',
    'Overage: $0.25 per prompt',
    'Best value per prompt',
    'Cancel anytime',
  ],
};

export const PLAN_LABELS = {
  payg: 'Legacy PAYG',
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
};
